<template>
    <div class="wrapper blog-post">
        <div class="page-header page-header-small" style="background:#183858b3;">
            <parallax class="page-header-image" :style="{'background-image': 'url('+article.headerimg+')'}"></parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title"><input type="text" class="title" v-model="article.title"/></h2>
                        <h4 style="margin-top:10px;"><input type="text" v-model="article.subheading"/></h4>
                        <input type="text" v-model="article.headerimg"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="button-container">
                            <!-- <a href="javascript:;" class="btn btn-primary btn-round btn-lg" style="pointer-events:none;">
                                {{displaydate}}
                            </a> -->
                            <a href="javascript:;" class="btn btn-success btn-round btn-lg" @click="postNew()">
                                Submit
                            </a>
                            <a href="javascript:;" class="btn btn-neutral btn-round btn-lg" style="pointer-events:none;" v-if="submitMessage != ''">
                                {{submitMessage}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" style="padding-bottom:0px;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h3 class="title"><input type="text" v-model="article.heading"/></h3>
                            <p>
                                <textarea v-model="article.body"/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section-blog col-md-10 ml-auto mr-auto">
                <div class="container">
                    <div class="section-story-overview">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="image-container image-left" :style="{'background-image': 'url('+article.img1+')'}">
                                    <!-- First image on the left side -->
                                    <p class="blockquote blockquote-primary">
                                        <textarea type="text" v-model="article.quote"/>
                                    </p>
                                </div>
                                <!-- Second image on the left side of the article -->
                                <div class="image-container image-left-bottom"
                                     :style="{'background-image': 'url('+article.img2+')'}">
                                </div>
                            </div>
                            <div class="col-md-5">
                                <!-- First image on the right side, above the article -->
                                <div class="image-container image-right"
                                     :style="{'background-image': 'url('+article.img3+')'}">
                                </div>
                                img1 link: <input type="text" v-model="article.img1"/><br/>
                                img2 link: <input type="text" v-model="article.img2"/><br/>
                                img3 link: <input type="text" v-model="article.img3"/>
                                <h3>
                                    <input type="text" v-model="article.heading2"/>
                                </h3>
                                <p>
                                    <textarea v-model="article.readmore"/><br/>
                                    <textarea v-model="article.body2"/>
                                </p>
                            </div>
                            <div class="col-md-8 ml-auto mr-auto">
                                <p>
                                    <textarea v-model="article.body3"/>
                                </p>
                            </div>
                            <div class="col-md-8 ml-auto mr-auto">
                                link text: <input type="text" v-model="article.linktext"/><br/>
                                <select v-model="article.linkto">
                                    <option disabled value="">Select One</option>
                                    <option>/facility-refrigeration-controls</option>
                                    <option>/facility-refrigeration-engineering</option>
                                    <option>https://gamsplus.com</option>
                                    <option>https://parts.electronictechcorp.com/</option>
                                </select><br/>
                                custom link: <input type="text" v-model="article.linkto"/><br/>
                                <a href="#pablo" class="btn btn-primary btn-lg mr-3" style="pointer-events:none;">
                                    {{article.linktext}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section-blog-info">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <div class="row">
                                <div class="blog-tags">
                                        Tags:
                                        
                                        <!-- <template v-for="(tag,index) in article.tags"><span class="label label-primary" :key="index">{{tag}}</span></template> -->
                                        <template v-for="(tag,index) in article.tags">
                                            <span :key="tag" :class="{'text-info': tag == 'Engineering', 'text-success': tag == 'Controls', 'text-danger': tag == 'Monitoring', 'text-warning': tag == 'Parts'}">{{tag}}</span>
                                            <span :key="index" v-if="index < article.tags.length -1">, </span>
                                        </template>
                                        <select v-model="article.tags" multiple>
                                            <option disabled value="">Select at least 1</option>
                                            <option>Controls</option>
                                            <option>Engineering</option>
                                            <option>Monitoring</option>
                                            <option>Parts</option>
                                        </select>
                                    </div>
                                <!-- <div class="col-md-6">
                                    <a href="#pablo" class="btn btn-google btn-round pull-right">
                                        <i class="fab fa-google"></i> 232
                                    </a>
                                    <a href="#pablo" class="btn btn-twitter btn-round pull-right">
                                        <i class="fab fa-twitter"></i> 910
                                    </a>
                                    <a href="#pablo" class="btn btn-facebook btn-round pull-right">
                                        <i class="fab fa-facebook-square"></i> 872
                                    </a>
                                </div> -->
                            </div>
                            <hr/>
                            <card type="profile" plain>
                                <template slot="raw-content">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="card-avatar">
                                                <img class="img img-raised" :src="article.authorimg">
                                                <div class="ripple-container"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-10">
                                            <h4 class="card-title"><input type="text" v-model="article.author"/><input type="text" v-model="article.authorimg"/></h4>
                                            <p class="description"><textarea v-model="article.authorquote"/>.</p>
                                        </div>
                                        <!-- <div class="col-md-2">
                                            <button type="button" class="btn btn-default pull-right btn-round">Follow
                                            </button>
                                        </div> -->
                                    </div>
                                </template>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="container" v-if="latest != null && latest.length > 0">
                <div class="section">
                    <h3 class="title text-center">You may also be interested in</h3>
                    <br/>
                    <div class="row">
                        <div class="col-md-4" :class="{'ml-auto mr-auto': latest.length < 3}" v-for="article in latest" :key="article._id">
                            <card type="blog" plain>
                                <img slot="image" class="img rounded img-raised" src="img/bg5.jpg"/>
                                <h6 class="category text-info"><span v-for="{index, tag} in article.tags" :key="tag">{{tag}} <span v-if="index < article.tags.length -1"></span></span></h6>
                                <h4 class="card-title">
                                    <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                </h4>
                                <p class="card-description">
                                    {{article.readmore}}
                                    <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                </p>
                                <div class="author">
                                    <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                    <span>{{article.author}}</span>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
  import { Card, Button, Comment, Badge, InfoSection, Checkbox } from '@/components';

  export default {
    name: 'blog-post',
    bodyClass: 'blog-post',
    components: {
      Card,
      InfoSection,
      Badge,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        article: {
            _id: '',
            date: new Date(),
            tags: [],
            title: 'title',
            readmore: 'readmore',
            body: '<p></p>',
            author: 'author',
            authorimg: 'img/buck.jpg',
            style: 0,
            img1: 'img/20160727_163723.jpg',
            img2: 'img/20160727_163723.jpg',
            img3: 'img/20160727_163723.jpg',
            thumbnail: 'thumbnail',
            heading: 'heading',
            heading2: 'heading2',
            headerimg: 'img/20161103_100923_1.jpg',
            subheading: 'subheading',
            body2: '<p></p>',
            body3: '<p></p>',
            quote: 'quote',
            authorquote: 'author quote',
            linkto: '',
            linktext: '',
            keywords: '',
            description: ''
        },
        domain: 'https://api.website.gamsplus.systems',
        latest: null,
        submitMessage: '',
        loadingSubmit: false
        
      }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        // getLatest() {
        //     this.$http.get(this.domain+'/articles/latest',{
        //         headers: {
        //             'content-type' : 'application/json'
        //         }
        //     }).then(function(data){
        //         this.latest = data.body
        //     })
        // },
        postNew() {
            this.article._id = this.article.title.replace(/ /g,"_")
            this.loadingSubmit = true
            this.$http.post(this.domain+'/articles/add',{
                    'article': this.article,
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.loadingSubmit = false
                if(data.body == 'error'){
                    this.submitMessage = 'Error'
                } else {
                    this.$router.push({ path: '/article', query: { id: data.body }})
                }
                
                
            })
        },
    },
    computed: {
        // displaydate () {
        //     // return this.article.date.toLocaleDateString("en-US")
        // },
    },
  }
</script>
<style scoped>
.page-header input[type="text"] {
    color: white;
}
input[type="text"] {
    background: transparent;
    border: 0px;
}
textarea{
    width:100%;
    min-height:300px;
}
.section-story-overview p.blockquote {
    width: 350px;
}
</style>